import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  tabsName: {
    id: 'USSport.CompetitionList.sortHeader.Name',
    defaultMessage: 'Name',
  },
  tabsScarcity: {
    id: 'USSport.CompetitionList.sortHeader.Scarcity',
    defaultMessage: 'Scarcity',
  },
  tabsCap: {
    id: 'USSport.CompetitionList.sortHeader.Cap',
    defaultMessage: 'Cap',
  },
  tabsRewards: {
    id: 'USSport.CompetitionList.sortHeader.Rewards',
    defaultMessage: 'Rewards',
  },
  tabsParticipants: {
    id: 'USSport.CompetitionList.sortHeader.Participants',
    defaultMessage: 'Participants',
  },
  tabsRank: {
    id: 'USSport.CompetitionList.sortHeader.Rank',
    defaultMessage: 'Rank',
  },
});
